// extracted by mini-css-extract-plugin
export default {"card":"v4-z"};